export default __webpack_public_path__ + "ce9b428360897fcf24ca4e9c121291de.png";